import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "./headerPayment.css";
import ListPayment from "../Payments/listPayments";
import { Skeleton } from "antd";
import ListRequestPaymentsRefund from "../Payments/requestPaymentRefund";

const STORAGE_KEY = "payment_header_tab";

const HeaderPayments = () => {
  const [selectedTable, setSelectedTable] = useState(
    localStorage.getItem(STORAGE_KEY) || "payments_list"
  );

  const [loading, setLoading] = useState(false);

  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;


    setLoading(true);
    setSelectedTable(table);
    localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className="bg-white border-10 padding-10 shadow-box">
          <div className="hover_panel">
            <h4
              className={selectedTable === "payments_list" ? "clicked" : ""}
              onClick={() => handleTableSelection("payments_list")}
            >
              Payment List
            </h4>
            <h4
              className={selectedTable === "request_payments_list" ? "clicked" : ""}
              onClick={() => handleTableSelection("request_payments_list")}
            >
              Request Payment List
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div style={{ display: loading ? "none" : "block" }} className="fade-wrapper">
          <div
            className="fade-tab"
            style={{ display: selectedTable === "payments_list" ? "block" : "none" }}
          >
            <ListPayment />
          </div>

          <div
            className="fade-tab"
            style={{ display: selectedTable === "request_payments_list" ? "block" : "none" }}
          >
            <ListRequestPaymentsRefund />
          </div>
        </div>
    </div>
    </MainLayout >
  );
};

export default HeaderPayments;
